import { create } from "zustand";
import { v4 as uuidv4 } from "uuid";
import type { SelectorHook } from "./types";

interface Popover {
  id: string;
  Popover: React.ElementType;
  anchorEl: HTMLElement | null;
  props?: Record<string, any>;
  child?: React.ReactNode;
}

interface PopoverState {
  popovers: Popover[];
  pushPopover: (
    Popover: React.ElementType,
    anchorEl: HTMLElement | null,
    props?: Record<string, any>,
    childFactory?: (id: string) => React.ReactNode
  ) => string;
  popPopover: (id: string) => void;
}

const usePopoverStore = create<PopoverState>((set) => ({
  popovers: [],
  pushPopover(Popover, anchorEl, props, childFactory) {
    const id = uuidv4();
    const child = childFactory ? childFactory(id) : null;
    set((state) => ({
      popovers: [...state.popovers, { id, Popover, anchorEl, props, child }],
    }));
    return id;
  },
  popPopover: (id) => {
    set((state) => ({
      popovers: state.popovers.filter((popover) => popover.id !== id),
    }));
  },
}));

export const usePopover: SelectorHook<PopoverState, "popovers"> = (
  selector = (state: PopoverState) => state.popovers
) => usePopoverStore(selector);
